<template>
  <div class="satisfaction-survey-management">
    <div v-if="showLocale" class="language-preview">
      <div
        v-for="(item, index) in previewLocaleList"
        class="language-item link"
        :key="index"
        :class="item.dataKey === activePreviewLocale && 'is-active'"
        @click="handlePreviewLanguage(item)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
    <el-menu
      router
      class="menu-list"
      mode="horizontal"
      :default-active="activeIndex"
    >
      <el-menu-item
        v-for="(item, index) in tabList"
        class="menu-item"
        :key="index"
        :index="item.path"
      >
        {{ item.title || $t(item.i18nTitle) }}
      </el-menu-item>
    </el-menu>
    <router-view class="content"/>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      activeIndex: null,
      i18nPrefix: 'admin.company.jobApplication',
      activePreviewLocale: '',
      previewLocaleList: [
        {
          dataKey: 'en',
          label: 'English'
        },
        {
          dataKey: 'cn',
          label: '简体中文'
        },
        {
          dataKey: 'tc',
          label: '繁體中文'
        }
      ]
    }
  },
  computed: {
    activeTab () {
      return this.$route.query.tab
    },
    tabList () {
      const basePath = '/v-admin/job-application-management'
      const routes = [
        { path: `${basePath}/micro-site/list`, i18nTitle: `${this.i18nPrefix}.tabMenu.microSite` },
        { path: `${basePath}/question/list`, i18nTitle: `${this.i18nPrefix}.tabMenu.question` },
        { path: `${basePath}/step/list`, i18nTitle: `${this.i18nPrefix}.tabMenu.step` },
        { path: `${basePath}/questionnaire/list`, i18nTitle: `${this.i18nPrefix}.tabMenu.questionnaire` },
        { path: `${basePath}/email-template/list`, i18nTitle: `${this.i18nPrefix}.tabMenu.emailTemplate` }
      ]
      return _.map(routes, (item) => {
        return {
          path: item.path,
          i18nTitle: item.i18nTitle
        }
      })
    },
    showMenu () {
      return this.$route.meta?.showMenu
    },
    showLocale () {
      return this.$route.meta?.showLocale
    }
  },
  created () {
    const locale = this.$i18n.locale
    if (['tw', 'hk'].includes(locale)) {
      this.activePreviewLocale = 'tc'
    } else if (['zh'].includes(locale)) {
      this.activePreviewLocale = 'cn'
    } else {
      this.activePreviewLocale = 'en'
    }
  },
  methods: {
    handlePreviewLanguage (item) {
      this.activePreviewLocale = item.dataKey
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.activeIndex = this.$route.path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.satisfaction-survey-management {
  position: relative;

  .menu-list {
    .menu-item {
      font-size: 14px;
      line-height: 30px;
      padding: 0;
      margin: 0 20px;
      height: 30px;

      &:first-child {
        margin-left: 0;
      }
    }

    .menu-item.is-active {
      color: #0096cc;
      border-bottom: 1px solid #0096cc;
    }
  }

  .content {
    padding-top: 20px;
  }

  .language-preview {
    display: flex;
    position: absolute;
    right: 0;
    z-index: 1;

    .language-item {
      line-height: 15px;

      &:not(:last-child) {
        border-right: 1px solid #bfbfbf;
      }

      span {
        padding: 0 10px;
        vertical-align: middle;
      }
    }
  }
}
</style>
